import { render } from "./Sakuhin.vue?vue&type=template&id=365ae425&scoped=true"
import script from "./Sakuhin.vue?vue&type=script&lang=js"
export * from "./Sakuhin.vue?vue&type=script&lang=js"

import "./Sakuhin.vue?vue&type=style&index=0&id=365ae425&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365ae425"]])

export default __exports__